export function getInventoryVariantText(variantName?: string | null, isTechnical?: boolean | null): string {
    if (isTechnical) {
        return '';
    }

    return String(variantName || '').trim();
}

export function getInventoryCompositeLabel(itemName?: string | null, variantName?: string | null, isTechnical?: boolean | null): string {
    const cleanItemName = String(itemName || '').trim();
    const cleanVariantName = getInventoryVariantText(variantName, isTechnical);

    return [cleanItemName, cleanVariantName].filter(Boolean).join(' · ');
}

export function getVisibleInventoryVariants<T extends { isTechnical?: boolean | null }>(variants?: T[] | null): T[] {
    return (variants || []).filter(variant => !variant.isTechnical);
}
